const endpoint={
    get(){
        return '/api/';
    }
};

export default endpoint;
